import { useMediaQuery, useTheme } from '@mui/material';
import { useMemo, useState } from 'react';

const BREAKPOINT = 'md';

export const useIsMobile = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(BREAKPOINT));
};

export const useResponsiveSideBar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(BREAKPOINT));
  const [isHovered, setIsHovered] = useState(false);
  const showExpandedContent = useMemo(() => !isMobile || isHovered, [isMobile, isHovered]);

  const handleMouseEnter = () => {
    if (isMobile) {
      setIsHovered(true);
    }
  };

  const handleMouseLeave = () => {
    if (isMobile) {
      setIsHovered(false);
    }
  };

  return {
    handleMouseEnter,
    handleMouseLeave,
    isCollapsed: isMobile,
    isHovered,
    showExpandedContent,
  };
};
